"use strict";
import ApiService from "@/core/services/api.service";

const baseURL = "Map";

export default {
  getOnlineReport(payload) {
    return ApiService.post(`${baseURL}/GetOnlineReport`, payload, {
      ignoreUnhandledExceptionAlert: true
    });
  },
  getOnlineTrackersReport(payload) {
    return ApiService.post(`${baseURL}/GetOnlineTrackersReport`, payload, {
      ignoreUnhandledExceptionAlert: true
    });
  },
  getOnlineArbaeenData(payload) {
    return ApiService.post(`${baseURL}/GetOnlineArbaeenData`, payload, {
      ignoreUnhandledExceptionAlert: true
    });
  },
  getDashboardData(payload) {
    return ApiService.post(`${baseURL}/GetDashboardData`, payload, {
      ignoreUnhandledExceptionAlert: true,
      ignoreGlobalLoader: true
    });
  },
  getAllCarStates() {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetAllCarStates`).then(({ data }) =>
        resolve(data)
      );
    });
  },
  getTollData() {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetTollData`).then(({ data }) =>
        resolve(data)
      );
    });
  },
  getCameraData() {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetCameraData`).then(({ data }) =>
        resolve(data)
      );
    });
  },
  arbaeenGetFences() {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/ArbaeenGetFences`).then(({ data }) => {
        resolve(data);
      });
    });
  },
  getBorderPoints() {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetBorderPoints`).then(({ data }) =>
        resolve(data)
      );
    });
  },
  getArbaeenReport(payload) {
    return ApiService.post(`${baseURL}/GetArbaeenReport`, payload);
  },
  getHeatMapData(payload) {
    return ApiService.post(`${baseURL}/GetHeatMapData`, payload);
  },
  getWeatherStations() {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetWeatherStations`).then(({ data }) =>
        resolve(data)
      );
    });
  },
  getStationForecast(stationID) {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetStationForecast/${stationID}`).then(
        ({ data }) => resolve(data)
      );
    });
  },
  getStationNearVehicles(stationID) {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetStationNearVehicles/${stationID}`).then(
        ({ data }) => resolve(data)
      );
    });
  }
};
